import { api } from 'API';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/users';

export interface UserData {
  firstName: string;
  lastName: string;
  caseNumber: string;
  israeliId: string;
  district: string;
  email: string;
  getFullMainPhone: string;
  gender?: string;
}

export interface User {
  authenticatedUser: Partial<UserData>;
  fakeUser?: Partial<UserData>;
  isAdminAuthenticatedUser: boolean;
  hasUnreadedNotifications: boolean;
  isRepresentativeAuthenticatedUser: boolean;
  isShikumAuthenticatedUser: boolean;
  representativeName?: string;
}

export const getUser = async (isrId?: string) => {
  const users = await api.get<User>(
    isrId ? `${baseUrl}?isrId=${isrId}` : addImposterToUrl(baseUrl, true)
  );
  if (users.data) {
    return users.data;
  }
};
